(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'slider') return;

      this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      if (this.slides.length <= 1) return;

      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) this.currentIndex = 0;
      this.isAnimating = false;
      this.animationDuration = 450;

      this.prevButton = this.querySelector('.announcement-bar__button--prev');
      this.nextButton = this.querySelector('.announcement-bar__button--next');

      this.handlePrev = () => this.showSlide(this.currentIndex - 1);
      this.handleNext = () => this.showSlide(this.currentIndex + 1);

      if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);

      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.addEventListener('mouseleave', this.startAutoplay.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
      this.stopAutoplay();
    }

    showSlide(index) {
      if (this.isAnimating) return;

      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[nextIndex];

      this.isAnimating = true;
      currentSlide.classList.add('is-leaving');
      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      window.setTimeout(() => {
        currentSlide.classList.remove('is-leaving');
        this.currentIndex = nextIndex;
        this.isAnimating = false;
      }, this.animationDuration);
    }

    startAutoplay() {
      this.stopAutoplay();
      const interval = Number(this.dataset.interval) || 4000;
      this.autoplayTimer = window.setInterval(() => this.showSlide(this.currentIndex + 1), interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar-section')) {
    customElements.define('announcement-bar-section', AnnouncementBarSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.background-image-text-section');

    if (!section || section.dataset.parallax !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const media = section.querySelector('[data-background-media]');
    if (!media) return;

    let ticking = false;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const shift = (progress - 0.5) * 28;
      const axis = getComputedStyle(section).getPropertyValue('--background-image-text-parallax-axis').trim();

      if (axis === 'horizontal') {
        media.style.transform = `translate3d(${shift}px, 0, 0) scale(1.06)`;
      } else {
        media.style.transform = `translate3d(0, ${shift}px, 0) scale(1.06)`;
      }
      ticking = false;
    };

    const requestUpdate = () => {
      if (window.innerWidth <= 749) {
        media.style.transform = 'none';
        return;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartPageController {
    constructor(root) {
      this.root = root;
      if (!this.root) return;

      this.currency = this.root.dataset.cartCurrency || 'USD';
      this.showCompareAt = this.root.dataset.cartPageShowCompareAt === 'true';
      this.priceOrder = this.root.dataset.cartPagePriceOrder || 'sale_first';
      this.showSavings = this.root.dataset.cartPageShowSavings === 'true';
      this.savingsItemTemplate = this.root.dataset.cartPageSavingsItemTemplate || '';
      this.savingsTotalTemplate = this.root.dataset.cartPageSavingsTotalTemplate || '';

      this.decreaseLabel = this.root.dataset.cartPageDecreaseLabel || '';
      this.increaseLabel = this.root.dataset.cartPageIncreaseLabel || '';
      this.quantityLabel = this.root.dataset.cartPageQuantityLabel || '';
      this.removeLabel = this.root.dataset.cartPageRemoveLabel || '';
      this.emptyTitle = this.root.dataset.cartPageEmptyTitle || '';
      this.emptyCopy = this.root.dataset.cartPageEmptyCopy || '';
      this.continueUrl = this.root.dataset.cartPageContinueUrl || '/';
      this.continueLabel = this.root.dataset.cartPageContinueLabel || '';

      this.shippingEnabled = this.root.dataset.cartPageShippingEnable === 'true';
      this.shippingThreshold = Number(this.root.dataset.cartPageShippingThreshold || 0);
      this.shippingRemainingTemplate = this.root.dataset.cartPageShippingRemainingTemplate || '';
      this.shippingCompleteTemplate = this.root.dataset.cartPageShippingCompleteTemplate || '';
      this.shippingReward = this.root.dataset.cartPageShippingReward || '';

      this.countNode = this.root.querySelector('[data-cart-page-count]');
      this.subtotalNode = this.root.querySelector('[data-cart-page-subtotal]');
      this.compareSubtotalNode = this.root.querySelector('[data-cart-page-compare-subtotal]');
      this.summarySavingsNode = this.root.querySelector('[data-cart-page-summary-savings]');
      this.footer = this.root.querySelector('[data-cart-page-footer]');
      this.shippingBar = this.root.querySelector('[data-cart-page-shipping-bar]');
      this.shippingMessage = this.root.querySelector('[data-cart-page-shipping-message]');
      this.shippingFill = this.root.querySelector('[data-cart-page-shipping-fill]');

      this.variantCompareAtPrices = this.parseVariantCompareAtPrices();
      this.pendingItemKeys = new Set();

      this.root.addEventListener('click', (event) => this.handleClick(event));
      this.root.addEventListener('change', (event) => this.handleChange(event));
    }

    handleClick(event) {
      const quantityTrigger = event.target.closest('[data-cart-quantity-change]');
      if (quantityTrigger) {
        const item = quantityTrigger.closest('[data-cart-item-key]');
        if (!item) return;
        const key = item.dataset.cartItemKey;
        if (!key || this.pendingItemKeys.has(key)) return;

        const delta = Number(quantityTrigger.dataset.cartQuantityDelta || 0);
        const input = item.querySelector('[data-cart-quantity-input]');
        const current = Number(input?.value || 0);
        this.changeItem(key, Math.max(0, current + delta));
        return;
      }

      const removeTrigger = event.target.closest('[data-cart-remove]');
      if (removeTrigger) {
        event.preventDefault();
        const item = removeTrigger.closest('[data-cart-item-key]');
        if (!item) return;
        const key = item.dataset.cartItemKey;
        if (!key || this.pendingItemKeys.has(key)) return;
        this.changeItem(key, 0);
      }
    }

    handleChange(event) {
      const input = event.target.closest('[data-cart-quantity-input]');
      if (!input) return;
      const item = input.closest('[data-cart-item-key]');
      if (!item) return;
      const key = item.dataset.cartItemKey;
      if (!key || this.pendingItemKeys.has(key)) return;
      this.changeItem(key, Math.max(0, Number(input.value) || 0));
    }

    async changeItem(key, quantity) {
      if (!key || this.pendingItemKeys.has(key)) return;

      this.pendingItemKeys.add(key);
      this.setItemPendingState(key, true);

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });

        if (!response.ok) throw new Error('Unable to update cart item');

        const cart = await response.json();
        this.render(cart);

        if (window.cartDrawer && typeof window.cartDrawer.render === 'function') {
          window.cartDrawer.render(cart);
        }
      } catch (error) {
        console.error(error);
        window.location.reload();
      } finally {
        this.pendingItemKeys.delete(key);
      }
    }

    setItemPendingState(key, isPending) {
      const item = this.root.querySelector(`[data-cart-item-key="${CSS.escape(key)}"]`);
      if (!item) return;
      item.classList.toggle('is-pending', isPending);
      item.setAttribute('aria-busy', isPending ? 'true' : 'false');
      item.querySelectorAll('button, input').forEach((el) => {
        el.disabled = isPending;
      });
    }

    render(cart) {
      this.hydrateCompareAtPrices(cart);
      const itemCount = cart.item_count || 0;

      if (this.countNode) this.countNode.textContent = itemCount;
      if (this.footer) this.footer.hidden = itemCount === 0;
      if (this.subtotalNode) this.subtotalNode.textContent = this.formatMoney(cart.total_price || 0);

      const compareTotal = (cart.items || []).reduce(
        (sum, item) => sum + (item.compare_at_line_price || item.final_line_price || 0),
        0
      );
      if (this.compareSubtotalNode) {
        const show = this.showCompareAt && compareTotal > (cart.total_price || 0);
        this.compareSubtotalNode.hidden = !show;
        this.compareSubtotalNode.textContent = show ? this.formatMoney(compareTotal) : '';
      }

      if (this.summarySavingsNode) {
        const cartSavings = compareTotal - (cart.total_price || 0);
        const showCartSavings = this.showCompareAt && this.showSavings && cartSavings > 0;
        this.summarySavingsNode.hidden = !showCartSavings;
        this.summarySavingsNode.textContent = showCartSavings
          ? this.savingsTotalTemplate.replace('[[amount]]', this.formatMoney(cartSavings))
          : '';
      }

      this.updateShippingBar(cart);

      const body = this.root.querySelector('[data-cart-page-body]');
      if (!body) return;

      if (!itemCount) {
        body.innerHTML = `
          <div class="cart-drawer__empty">
            <p class="cart-drawer__empty-title">${this.escapeHtml(this.emptyTitle)}</p>
            <p class="cart-drawer__empty-copy">${this.escapeHtml(this.emptyCopy)}</p>
            <a href="${this.escapeHtml(this.continueUrl)}" class="button button--primary cart-drawer__empty-cta">
              ${this.escapeHtml(this.continueLabel)}
            </a>
          </div>
        `;
        return;
      }

      const itemsMarkup = cart.items
        .map((item) => {
          const imageMarkup = item.image
            ? `<a href="${this.escapeHtml(item.url)}" class="cart-drawer__item-media">
                <img src="${this.escapeHtml(item.image)}" alt="${this.escapeHtml(item.product_title)}" class="cart-drawer__item-image" loading="lazy">
              </a>`
            : `<div class="cart-drawer__item-media"></div>`;

          const variantMarkup =
            item.variant_title && item.variant_title !== 'Default Title'
              ? `<p class="cart-drawer__item-variant">${this.escapeHtml(item.variant_title)}</p>`
              : '';

          const itemHasCompare = this.showCompareAt && (item.compare_at_line_price || 0) > (item.final_line_price || 0);
          const propertiesMarkup = Object.entries(item.properties || {})
            .filter(([key, value]) => value !== null && value !== undefined && value !== '' && !key.startsWith('_'))
            .map(([key, value]) => `<p class="cart-drawer__item-property">${this.escapeHtml(key)}: ${this.escapeHtml(value)}</p>`)
            .join('');
          const salePriceMarkup = `<p class="cart-drawer__item-price">${this.formatMoney(item.final_line_price)}</p>`;
          const comparePriceMarkup = itemHasCompare
            ? `<p class="cart-drawer__item-compare-price">${this.formatMoney(item.compare_at_line_price)}</p>`
            : '';
          const pricesMarkup =
            this.priceOrder === 'compare_first' && itemHasCompare
              ? `${comparePriceMarkup}${salePriceMarkup}`
              : `${salePriceMarkup}${comparePriceMarkup}`;
          const itemSavingsMarkup =
            this.showSavings && itemHasCompare
              ? `<p class="cart-drawer__item-savings">${this.escapeHtml(
                  this.savingsItemTemplate.replace('[[amount]]', this.formatMoney(item.compare_at_line_price - item.final_line_price))
                )}</p>`
              : '';

          const isPending = this.pendingItemKeys.has(item.key);

          return `
            <li class="cart-drawer__item${isPending ? ' is-pending' : ''}" data-cart-item-key="${item.key}" aria-busy="${isPending ? 'true' : 'false'}">
              ${imageMarkup}
              <div class="cart-drawer__item-content">
                <div class="cart-drawer__item-top">
                  <div>
                    <a href="${this.escapeHtml(item.url)}" class="cart-drawer__item-title">${this.escapeHtml(item.product_title)}</a>
                    ${variantMarkup}
                    ${propertiesMarkup}
                  </div>
                  <div class="cart-drawer__item-prices">
                    ${pricesMarkup}
                  </div>
                  ${itemSavingsMarkup}
                </div>
                <div class="cart-drawer__item-bottom">
                  <div class="cart-drawer__quantity">
                    <button type="button" class="cart-drawer__quantity-button" data-cart-quantity-change data-cart-quantity-delta="-1" aria-label="${this.escapeHtml(this.decreaseLabel)}" ${isPending ? 'disabled' : ''}>-</button>
                    <input type="number" class="cart-drawer__quantity-value" value="${item.quantity}" min="1" aria-label="${this.escapeHtml(this.quantityLabel)}" data-cart-quantity-input ${isPending ? 'disabled' : ''}>
                    <button type="button" class="cart-drawer__quantity-button" data-cart-quantity-change data-cart-quantity-delta="1" aria-label="${this.escapeHtml(this.increaseLabel)}" ${isPending ? 'disabled' : ''}>+</button>
                  </div>
                  <button type="button" class="cart-drawer__remove" data-cart-remove ${isPending ? 'disabled' : ''} aria-label="${this.escapeHtml(this.removeLabel)}: ${this.escapeHtml(item.product_title)}">${this.escapeHtml(this.removeLabel)}</button>
                </div>
              </div>
            </li>
          `;
        })
        .join('');

      body.innerHTML = `<ul class="cart-drawer__items" data-cart-page-items role="list">${itemsMarkup}</ul>`;
    }

    updateShippingBar(cart) {
      if (!this.shippingEnabled || !this.shippingBar || this.shippingThreshold <= 0) return;

      const itemCount = cart.item_count || 0;
      this.shippingBar.hidden = itemCount === 0;
      if (itemCount === 0) {
        this.shippingBar.classList.remove('is-complete');
        if (this.shippingFill) this.shippingFill.style.width = '0%';
        return;
      }

      const total = cart.total_price || 0;
      const remaining = Math.max(0, this.shippingThreshold - total);
      const percent = Math.min(100, Math.round((total / this.shippingThreshold) * 100));

      if (this.shippingFill) this.shippingFill.style.width = `${percent}%`;

      if (remaining <= 0) {
        this.shippingBar.classList.add('is-complete');
        if (this.shippingMessage) this.shippingMessage.textContent = `🎉 ${this.shippingCompleteTemplate}`;
      } else {
        this.shippingBar.classList.remove('is-complete');
        if (this.shippingMessage) {
          this.shippingMessage.textContent = this.shippingRemainingTemplate
            .replace('[[amount]]', this.formatMoney(remaining))
            .replace('[[reward]]', this.shippingReward);
        }
      }
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: this.currency
      }).format((cents || 0) / 100);
    }

    escapeHtml(value) {
      return String(value || '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');
    }

    parseJsonNode(selector) {
      const node = this.root.querySelector(selector);
      if (!node) return null;
      try {
        return JSON.parse(node.textContent || '{}');
      } catch (error) {
        console.error(error);
        return null;
      }
    }

    parseVariantCompareAtPrices() {
      const value = this.parseJsonNode('[data-cart-page-compare-at-prices]');
      const prices = new Map();
      Object.entries(value || {}).forEach(([variantId, compareAtPrice]) => {
        const normalizedId = Number(variantId);
        if (!normalizedId) return;
        prices.set(normalizedId, Number(compareAtPrice || 0));
      });
      return prices;
    }

    hydrateCompareAtPrices(cart) {
      if (!this.showCompareAt || !cart?.items?.length) return;
      cart.items.forEach((item) => {
        const variantId = Number(item.variant_id || 0);
        const compareAtUnitPrice = Number(this.variantCompareAtPrices.get(variantId) || 0);
        const finalUnitPrice = Number(item.final_price || 0);
        item.compare_at_unit_price = compareAtUnitPrice;
        item.compare_at_line_price =
          compareAtUnitPrice > finalUnitPrice ? compareAtUnitPrice * Number(item.quantity || 0) : 0;
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('[data-cart-page]');
    if (root) new CartPageController(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            this._items.forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          }
        });
      });
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();
})();
